import React, { useState, useContext, useEffect, useMemo } from "react";
import logo from "./logo_only.png";
import { useMediaQuery } from "react-responsive";
import Dropdown from "../Dropdown/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { getUpdateRequest } from "../../Redux/thunks/getUpdateRequest";
import { UniqueIdContext } from "../../FinContext";
import { useNavigate } from "react-router-dom";
import {
    IoIosHome,
    IoIosNotifications,
    IoIosLogOut,
    IoMdArrowBack,
} from "react-icons/io";
import { useScrollPosition } from "../../Components/useScrollPosition";
import { persistor } from "../../Redux/store";
import ButtonDropDown from "../buttonDropDown";
import {
    RESET_ALL_STATES,
    setVerified,
    setAuthenticated,
} from "../../Redux/actions/actions";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import apiClient from "../../utils/apiClient";

const Navigation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [timeRemaining, setTimeRemaining] = useState(180);
    const { i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n.language);

    useEffect(() => {
        const sessionTimer = setInterval(() => {
            setTimeRemaining((prevTime) => {
                return Math.max(prevTime - 1, 0);
            });
        }, 1000);

        const resetSessionTimer = () => {
            clearInterval(sessionTimer);
            setTimeRemaining(180);
        };

        const logoutUser = () => {
            dispatch({ type: "LOGOUT" });
            dispatch({ type: RESET_ALL_STATES });
            persistor.purge();
            navigate("/");
        };

        const checkSessionTimeout = () => {
            if (timeRemaining <= 0) {
                logoutUser();
                console.log("logged out");
            }
        };

        const handleUserInteraction = () => {
            resetSessionTimer();
            checkSessionTimeout();
        };

        window.addEventListener("click", handleUserInteraction);
        window.addEventListener("keydown", handleUserInteraction);

        return () => {
            clearInterval(sessionTimer);
            window.removeEventListener("click", handleUserInteraction);
            window.removeEventListener("keydown", handleUserInteraction);
        };
    }, [dispatch, timeRemaining, navigate]);

    const isAuthenticated = useSelector(
        (state) => state.session.isAuthenticated
    );
    const dtoData = useSelector((state) => state.otp.data);

    const uniqueIdObject = useSelector((state) => state.uin);
    const uniqueId = uniqueIdObject.uin;

    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1224px)",
    });
    const scrollPosition = useScrollPosition();

    const [renderSection, setRenderSection] = useState(null);
    const [handleFetchClickTriggered, setHandleFetchClickTriggered] =
        useState(false);

    const { isLoading, error, data } = useSelector(
        (state) => state.residentlog
    );

    const arrayOfData =
        isAuthenticated && handleFetchClickTriggered ? data?.data : "";

    const formatDate = (dateStr) => {
        let originalDate = new Date(dateStr);
        var options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZone: "Europe/Istanbul",
        };
        return new Intl.DateTimeFormat("en-US", options)
            .format(originalDate)
            .replace(/T/g, "__T: ");
    };

    const sortedData = useMemo(() => {
        let sortableItems = [];
        try {
            sortableItems = [...arrayOfData];
        } catch (error) {
            console.log("error with data: ", error);
            // setErrorHandler();
        }
        sortableItems.sort((a, b) => {
            let dateA =
                a.status === "NEW"
                    ? new Date(a.createdDate)
                    : new Date(a.updatedDate);
            let dateB =
                b.status === "NEW"
                    ? new Date(b.createdDate)
                    : new Date(b.updatedDate);

            // Sorting in descending order
            return dateB - dateA;
        });

        return sortableItems.map((item) => ({
            ...item,
            createdDate: formatDate(item.createdDate),
            updatedDate: formatDate(item.updatedDate),
        }));
    }, [arrayOfData]);

    const separateDateAndTime = (dateString, timeString) => {
        const date = new Date(dateString);
        const datePart = date.toLocaleDateString();
        const timePart = timeString ? timeString : date.toLocaleTimeString();
        return { datePart, timePart };
    };

    const handleFetchClick = async () => {
        try {
            const response = await apiClient.get(`/updateRequest/${uniqueId}`);
            setHandleFetchClickTriggered(true);
            setRenderSection("data");
        } catch (error) {
            console.error("Error fetching update request:", error);
            setRenderSection("error");
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className='fixed top-0 w-full z-50'>
            {isDesktopOrLaptop ? (
                <nav
                    className={`${
                        scrollPosition > 0
                            ? "bg-nidblue text-white"
                            : "transparent text-white  bg-nidblue"
                    }
          w-full flex items-center justify-between px-10 z-50 font-barlow
        `}
                >
                    <div className='flex items-center py-1 md:pt-1'>
                        <div className='flex justify-start items-center'>
                            <IoMdArrowBack
                                className='w-8 h-8 mr-8 text-white cursor-pointer hover:text-gray-300'
                                onClick={handleGoBack}
                            />
                            <img
                                src={logo}
                                alt='Logo'
                                className='w-12 h-12 mr-2 p-0.5 stroke-lime-400  '
                            />
                            <div className='flex flex-col items-center justify-center '>
                                <span className='my-0 text-sm font-bold text-white font'>
                                    National ID
                                </span>
                                <span className='-my-1 text-sm font-bold text-white font-balow'>
                                    ብሔራዊ መታወቂያ
                                </span>
                            </div>
                        </div>

                        <div className='flex bg-red md:right-2 z-50'>
                            <ButtonDropDown />
                        </div>

                        {/* <div className="relative flex w-full z-50  justify-end  bg-nidblue/20 "><ButtonDropDown /> </div> */}
                    </div>

                    {/* <div className="flex items-center px-10 text-2xl font-extrabold text-white b-white/10 font-balow"> */}
                    {/* Welcome {dtoData.fullName.eng.split(' ')[0]} */}
                    {/*  dtoData.fullName?.amh || "", */}
                    {/* </div> */}

                    <div className='flex items-center text-xl font-semibold b-white/10 '>
                        {isAuthenticated ? (
                            <>
                                <div className='flex items-center px-10 text-base font-bold text-white b-white/10 font-balow'>
                                    {dtoData?.fullName?.eng?.split(" ")[0]}
                                    {/*  dtoData.fullName?.amh || "", */}
                                </div>

                                {/* Home Icon */}
                                <div
                                    className='cursor-pointer mx-2 bg-whit rounded-md   hover:scale-95 duration-300  transition-all  hover:ring-white ring-0.5 text-white hover:text-niblue  hover:bg-slate-500 p-1  '
                                    title='Dashboard'
                                >
                                    <IoIosHome
                                        className='w-7 h-7 m-1 duration-300 b-slate-600 hover:text-idgreen hover-scale-95'
                                        onClick={() => {
                                            navigate("/dashboard");
                                        }}
                                    />
                                </div>

                                {/* start Notification */}
                                <Dropdown
                                    button={
                                        <p
                                            className='cursor-pointer mx-2 bg-whit rounded-md   hover:scale-95 duration-300  transition-all  hover:ring-white ring-0.5 text-white hover:text-niblue  hover:bg-slate-500 p-1    '
                                            onClick={handleFetchClick}
                                        >
                                            <IoIosNotifications className='w-7 h-7 m-1 duration-300 b-slate-600 hover-scale-9' />
                                        </p>
                                    }
                                    animation='origin-[65%_0%] md:origin-top-right transition-all duration-500 ease-in-out'
                                    children={
                                        <div className=' mt-6 border rounded-t-lg rounded-b-lg  bg-white rounded-tl-lg  flex w-[460px] flex-col  shadow-3xl    shadow-nidblue'>
                                            <div className='py-2 font-bold text-center text-nidblue border- shadow-nidblue'>
                                                <p>UPDATE REQUEST STATUS</p>
                                            </div>
                                            {renderSection === "loading" && (
                                                <p className='flex items-center w-full text-center text-nidblue justify-center h-[200px] '>
                                                    Loading...
                                                </p>
                                            )}
                                            {renderSection === "error" && (
                                                <p className='text-nidblue'>
                                                    Error: {error.message}
                                                </p>
                                            )}
                                            {renderSection === "data" && (
                                                <div className='flex flex-col font-semibold w-full overflow-y-scroll py- h-[510px] b-slate-400'>
                                                    {sortedData
                                                        ?.slice()
                                                        .map((item) => {
                                                            const dateToShow =
                                                                item.status ===
                                                                "NEW"
                                                                    ? item.createdDate
                                                                    : item.updatedDate;
                                                            const {
                                                                datePart,
                                                                timePart,
                                                            } =
                                                                separateDateAndTime(
                                                                    dateToShow
                                                                );
                                                            if (
                                                                item.status ===
                                                                "INCOMPLETE"
                                                            ) {
                                                                return null; // Skip this item
                                                            }

                                                            let statusText;
                                                            let statusColorClass;
                                                            if (
                                                                item.status ===
                                                                "SUBMITTED"
                                                            ) {
                                                                statusText =
                                                                    "Update Request has been Approved, Updating process might take upto 48 hours.";
                                                                statusColorClass =
                                                                    "text-nidblue";
                                                            } else if (
                                                                item.status ===
                                                                "DECLINED"
                                                            ) {
                                                                statusText =
                                                                    "Update Request has been Rejected";
                                                                statusColorClass =
                                                                    "text-red-600 ";
                                                            } else if (
                                                                item.status ===
                                                                "NEW"
                                                            ) {
                                                                statusText =
                                                                    "Update Request is under review";
                                                                statusColorClass =
                                                                    "text-nidblue text-bold";
                                                            } else {
                                                                statusText =
                                                                    item.status;
                                                                statusColorClass =
                                                                    "text-nidblue text-bold";
                                                            }

                                                            return (
                                                                <>
                                                                    <div
                                                                        className='flex flex-col w-full pl-5 pr-2 text-lg border-t-2 border-gray-200 b-slate-700 hover:bg-gray-100 curs'
                                                                        key={
                                                                            item.id
                                                                        }
                                                                    >
                                                                        <p className='text-gray-700 opacity-0'>
                                                                            ______________________
                                                                        </p>
                                                                        <div
                                                                            className={`font-bold ${statusColorClass} flex w-full`}
                                                                        >
                                                                            {
                                                                                statusText
                                                                            }
                                                                        </div>

                                                                        {item.reason !==
                                                                        null ? (
                                                                            <div className='flex flex-wrap text-MetallicBlue'>
                                                                                <h1 className='pr-2 font-bold '>
                                                                                    Reason
                                                                                    :
                                                                                </h1>
                                                                                <div className='bg-amber-5 w-full max-w-fit whitespace-normal break-words'>
                                                                                    {
                                                                                        item.reason
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        <div className='flex text-MetallicBlue'>
                                                                            <h1 className='pr-2 font-bold '>
                                                                                Date
                                                                                :
                                                                            </h1>
                                                                            <div className='pr-2'>
                                                                                {" "}
                                                                                {
                                                                                    datePart
                                                                                }{" "}
                                                                            </div>
                                                                            <h1 className='pr-2 font-bold '>
                                                                                Time
                                                                                :
                                                                            </h1>
                                                                            <div className=''>
                                                                                {" "}
                                                                                {
                                                                                    timePart
                                                                                }{" "}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            );
                                                        })}
                                                </div>
                                            )}
                                        </div>
                                    }
                                    classNames={
                                        "py-0.5 px-0.5 top- -left-[230px] md:-left-[440px] rounded-lg w-max bg-nidbue overflow-"
                                    }
                                />

                                {/* LOGOUT BUTTON */}
                                <div
                                    className='cursor-pointer mx-2 bg-whit rounded-md   hover:scale-95 duration-300  transition-all  hover:ring-white ring-0.5 text-white hover:text-niblue  hover:bg-slate-500 p-1  '
                                    title='Log Out'
                                >
                                    <IoIosLogOut
                                        className='w-7 h-7 m-1 duration-300 b-slate-600 hover:text-idgreen hover-scale-95'
                                        onClick={() => {
                                            dispatch({ type: "LOGOUT" });
                                            dispatch({
                                                type: RESET_ALL_STATES,
                                            });
                                            persistor.purge();
                                            navigate("/");
                                        }}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </nav>
            ) : (
                <nav className='relative flex items-center justify-between w-full py-3 pl-2  bg-nidblue'>
                    <div className='flex items-center'>
                        <IoMdArrowBack
                            className='w-8 h-8 mr-2 text-white cursor-pointer hover:text-gray-300'
                            onClick={handleGoBack}
                        />
                        <img
                            src={logo}
                            alt='Logo'
                            className='w-12 h-12 p-1 mr-2'
                        />

                        <div className='flex flex-col items-center justify-center '>
                            <span className='-my-1 text-sm font-bold text-white font'>
                                National ID
                            </span>
                            <span className='-my-1 text-sm font-bold text-white font-balow'>
                                ብሔራዊ መታወቂያ
                            </span>
                        </div>
                    </div>

                    <div className='flex items-center text-lg font-semibold '>
                        {isAuthenticated ? (
                            <>
                                {/* New language switcher button */}
                                <div
                                    className='cursor-pointer mx-2 text-white hover:text-niblue hover:bg-slate-500 rounded-md hover:scale-95 duration-100 transition- hover:ring-white ring-0.5 hover:text-white'
                                    title='Language'
                                    onClick={() => {
                                        const newLang =
                                            currentLang === "en" ? "amh" : "en";
                                        i18n.changeLanguage(newLang);
                                        setCurrentLang(newLang);
                                        localStorage.setItem(
                                            "LanguageState",
                                            JSON.stringify(newLang)
                                        );
                                    }}
                                >
                                    <button className='w-8 h-8 flex items-center justify-center text-2xl font-bold relative overflow-hidden'>
                                        <AnimatePresence mode='wait'>
                                            {currentLang === "en" ? (
                                                <motion.span
                                                    key='en'
                                                    initial={{
                                                        y: 20,
                                                        opacity: 0,
                                                    }}
                                                    animate={{
                                                        y: 0,
                                                        opacity: 1,
                                                    }}
                                                    exit={{
                                                        y: -20,
                                                        opacity: 0,
                                                    }}
                                                    transition={{
                                                        duration: 0.2,
                                                    }}
                                                    className='absolute'
                                                >
                                                    E
                                                </motion.span>
                                            ) : (
                                                <motion.span
                                                    key='amh'
                                                    initial={{
                                                        y: 20,
                                                        opacity: 0,
                                                    }}
                                                    animate={{
                                                        y: 0,
                                                        opacity: 1,
                                                    }}
                                                    exit={{
                                                        y: -20,
                                                        opacity: 0,
                                                    }}
                                                    transition={{
                                                        duration: 0.2,
                                                    }}
                                                    className='absolute'
                                                >
                                                    አ
                                                </motion.span>
                                            )}
                                        </AnimatePresence>
                                    </button>
                                </div>

                                <div
                                    className='cursor-pointer mx-2 text-white hover:text-niblue  hover:bg-slate-500 rounded-md   hover:scale-95 duration-100 transition-  hover:ring-white ring-0.5 hover:text-white '
                                    title='Dashboard'
                                >
                                    <IoIosHome
                                        className='m-1 duration-300 w-7 h-7 b-slate-600 hover:text-idgreen hover-scale-95'
                                        onClick={() => {
                                            navigate("/dashboard");
                                        }}
                                    />
                                </div>

                                {/* start Notification */}
                                <Dropdown
                                    button={
                                        <p
                                            className='cursor-pointer mx-2 text-white hover:text-niblue  hover:bg-slate-500 rounded-md   hover:scale-95 duration-100 transition-  hover:ring-white ring-0.5 hover:text-white '
                                            onClick={handleFetchClick}
                                        >
                                            <IoIosNotifications className='w-8 h-8 m-1 duration-300 b-slate-600 hover-scale-95' />
                                        </p>
                                    }
                                    animation='origin-[70%_0%] md:origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out'
                                    children={
                                        <div className='mt-4 border border-gray- flex w-[345px] h-[400px] flex-col gap-3 rounded-[20px] text- shadow-xl shadow-shadow-500 dark:!bg-navy-700  dark:shadow-none sm:w-[40px]'>
                                            <div className=' h-[90%] bg-white w-full p-3 overflow-y-scroll '>
                                                {data &&
                                                    sortedData?.map((item) => {
                                                        const {
                                                            datePart,
                                                            timePart,
                                                        } = separateDateAndTime(
                                                            item.updatedDate
                                                        );

                                                        if (
                                                            item.status ===
                                                            "INCOMPLETE"
                                                        ) {
                                                            return null; // Skip this item
                                                        }
                                                        // Determine the text based on the status
                                                        let statusText;
                                                        let statusColorClass;
                                                        if (
                                                            item.status ===
                                                            "APPROVED"
                                                        ) {
                                                            statusText =
                                                                "Update Request has been Approved";
                                                            statusColorClass =
                                                                "text-darkgreen bg-grey";
                                                        } else if (
                                                            item.status ===
                                                            "REJECTED"
                                                        ) {
                                                            statusText =
                                                                "Update Request has been Rejected";
                                                            statusColorClass =
                                                                "text-red-600 bg-grey";
                                                        } else {
                                                            statusText =
                                                                "Update Request is under review";
                                                            statusColorClass =
                                                                "text-black bg-grey";
                                                        }

                                                        return (
                                                            <div
                                                                className='flex flex-col b-slate-700 '
                                                                key={item.id}
                                                            >
                                                                <p>
                                                                    _____________________________________________
                                                                </p>
                                                                <div
                                                                    className={`font-bold ${statusColorClass}`}
                                                                >
                                                                    {statusText}
                                                                </div>

                                                                <div className='flex text-MetallicBlue'>
                                                                    <h1 className='pr-2 font-bold '>
                                                                        Status :
                                                                    </h1>
                                                                    <div className=''>
                                                                        {" "}
                                                                        {
                                                                            item.status
                                                                        }{" "}
                                                                    </div>
                                                                </div>

                                                                {item.reason && (
                                                                    <div className='flex text-MetallicBlue'>
                                                                        <h1 className='pr-2 font-bold '>
                                                                            Reason
                                                                            :{" "}
                                                                        </h1>
                                                                        <div className=''>
                                                                            {" "}
                                                                            {
                                                                                item.reason
                                                                            }{" "}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className='flex text-MetallicBlue'>
                                                                    <h1 className='pr-2 font-bold '>
                                                                        Date :{" "}
                                                                    </h1>
                                                                    <div className='pr-2'>
                                                                        {" "}
                                                                        {
                                                                            datePart
                                                                        }{" "}
                                                                    </div>
                                                                    <h1 className='pr-2 font-bold '>
                                                                        Time :{" "}
                                                                    </h1>
                                                                    <div className=''>
                                                                        {" "}
                                                                        {
                                                                            timePart
                                                                        }{" "}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    }
                                    classNames={
                                        "py-2 top-4 -left-[230px] md:-left-[440px] w-max"
                                    }
                                />

                                <div
                                    className='cursor-pointer mx-2 bg-whit rounded-md   hover:scale-95 duration-300  transition-all  hover:ring-white ring-0.5 text-white hover:text-niblue  hover:bg-slate-500 p-1  '
                                    title='Log Out'
                                >
                                    <IoIosLogOut
                                        className='w-8 h-8 m-1 duration-300 b-slate-600 hover:text-idgreen hover-scale-95'
                                        onClick={() => {
                                            dispatch({ type: "LOGOUT" });
                                            dispatch({
                                                type: RESET_ALL_STATES,
                                            });
                                            persistor.purge();
                                            navigate("/");
                                        }}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </nav>
            )}
        </div>
    );
};

export default Navigation;
